import { useTranslation } from "react-i18next";
import { labelFor } from "../services/enumLabels";

/**
 * A branch's gender. A single-gender business fixes it, so the field is shown
 * read-only with that gender (the server sets it regardless); a business that
 * serves both makes it a required choice. A legacy branch with none yet gets a
 * hint, because the API requires it on the next save.
 */
export default function BranchGenderField({
  allowedGenders,
  value,
  onChange,
  error,
  legacy = false,
  loading = false,
}) {
  const { t } = useTranslation();
  const fixed = allowedGenders.length === 1 ? allowedGenders[0] : null;

  if (fixed) {
    return (
      <div>
        <label className="field-label" htmlFor="gender">
          {t("branchForm.gender")}
        </label>
        <input
          id="gender"
          type="text"
          readOnly
          className="field-input cursor-not-allowed bg-raised text-ink-2"
          value={labelFor("gender", fixed)}
        />
        <p className="mt-1 text-xs text-ink-2">
          {t("branchForm.genderFixedHint", { gender: labelFor("gender", fixed) })}
        </p>
        {error && <p className="field-error">{error}</p>}
      </div>
    );
  }

  return (
    <div>
      <label className="field-label" htmlFor="gender">
        {t("branchForm.gender")} <span className="text-danger-text">*</span>
      </label>
      <select
        id="gender"
        className="field-input"
        value={value ?? ""}
        disabled={loading}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{loading ? t("common.loading") : "—"}</option>
        {allowedGenders.map((gender) => (
          <option key={gender} value={gender}>
            {labelFor("gender", gender)}
          </option>
        ))}
      </select>
      <p className={`mt-1 text-xs ${legacy ? "text-warning-text" : "text-ink-2"}`}>
        {legacy ? t("branchForm.genderLegacyHint") : t("branchForm.genderChooseHint")}
      </p>
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
